import { createSvgIconComponent } from "../";

export const IconDiscountTag = createSvgIconComponent({
  paths: [
    {
      d: "M47 37H4.857A4.817 4.817 0 010 32.143V4.857A4.817 4.817 0 014.857 0h42c2.143 0 4 .857 5.429 2.429L63 15.857c1.429 1.714 1.429 4.286 0 6L52.429 34.571C50.857 36.143 49 37 47 37zM4.857 1.857c-1.714 0-3 1.429-3 3v27.286c0 1.714 1.429 3 3 3h42c1.429 0 2.857-.572 3.857-1.714l10.572-12.715c.857-1 .857-2.571 0-3.714L50.57 3.714c-1-1.143-2.428-1.857-4-1.857H4.857z",
      props: {
        fill: "currentColor",
      },
    },
    {
      d: "M51.428 22.571c-2.285 0-4-1.857-4-4s1.857-4 4-4c1.143 0 2.143.429 2.857 1.143.715.714 1.143 1.714 1.143 2.857 0 1-.428 2.143-1.143 2.857-.857.715-1.857 1.143-2.857 1.143zm0-6.143c-1.143 0-2.143 1-2.143 2.143 0 1.143 1 2.143 2.143 2.143.572 0 1.143-.286 1.572-.571.428-.286.571-1 .571-1.572 0-.571-.286-1.143-.571-1.571-.429-.286-1-.572-1.572-.572zM48.286 8.572H5c-.57 0-1-.43-1-.858s.43-1 1-1h43.43c.57 0 1 .429 1 1 0 .572-.572.857-1.144.857z",
      props: {
        fill: "currentColor",
      },
    },
    {
      d: "M29.144 14c.714 0 1.143.714.714 1.286l-8.857 15.428a.786.786 0 01-.714.429c-.715 0-1.143-.714-.715-1.286L28.43 14.43a.786.786 0 01.714-.429zM16.143 18c0-2.143 1.572-3.857 3.857-3.857 2.286 0 3.857 1.714 3.857 3.857 0 2.143-1.571 3.857-3.857 3.857A3.841 3.841 0 0116.143 18zm6 0c0-1.286-.857-2.286-2.143-2.286-1.285 0-2.143 1-2.143 2.286s.858 2.286 2.143 2.286c1.286-.143 2.143-1 2.143-2.286zm3.429 9.428c0-2.142 1.571-3.857 3.857-3.857 2.286 0 3.857 1.715 3.857 3.857 0 2.143-1.572 3.858-3.857 3.858a3.841 3.841 0 01-3.857-3.858zm6 0c0-1.285-.857-2.285-2.143-2.285-1.286 0-2.143 1-2.143 2.285 0 1.286.857 2.286 2.143 2.286 1.286-.143 2.143-1 2.143-2.285z",
      props: {
        fill: "#F0D511",
      },
    },
  ],
  viewBox: "0 0 65 37",
  fill: "none",
});
